import { NativeModules } from 'react-native';

type Availability = 'Unavailable' | 'UpdateRequired' | 'Ready';

// align with the `data class WorkoutDataForExport`
interface IWorkoutData {
  fitillionId: string;
  healthConnectExerciseTypeId: number;
  endTimeMilliseconds: number;
  startTimeMilliseconds: number;
}

interface IHealthConnectWrapper {
  getAvailability(): Promise<Availability>;
  debug(): Promise<string>;
  initializeHealthConnect(): Promise<void>;
  isAllPermissionsGranted(): Promise<boolean>;
  requestPermissions(): Promise<boolean>;
  exportWorkout(workout: IWorkoutData): Promise<number>;
}

export default NativeModules.HealthConnectWrapper as IHealthConnectWrapper;
